<script setup lang="ts">
import { computed } from 'vue';

import { IconTelegram, IconMax, IconVk } from '@/shared/ui/icons';

interface Props {
  /** Провайдер в любом регистре: enum GraphQL приходит как `TELEGRAM`. */
  provider: string;
  size?: number;
}

const props = withDefaults(defineProps<Props>(), {
  size: 16,
});

const key = computed(() => props.provider.toLowerCase());
</script>

<template>
  <IconTelegram
    v-if="key === 'telegram'"
    :width="size"
    :height="size"
  />
  <IconMax
    v-else-if="key === 'max'"
    :width="size"
    :height="size"
  />
  <IconVk
    v-else-if="key === 'vk'"
    :width="size"
    :height="size"
  />
</template>
